<template>
  <VRow>
    <VCol cols="12" md="10" lg="5">
      <Preloader v-if="integrationDataLoading" />
      <VacancyIntegrationsList v-if="integrations.length && !integrationDataLoading" />
    </VCol>
  </VRow>
</template>

<script>
import VacancyIntegrationsList from '@/components/Integrations/IntegrationsList';
import useUser from '@/compositions/useUser';
import useIntegrations from '@/compositions/useIntegrations';
import useHHIntegration from '@/compositions/useHHIntegration';
import Preloader from '@/components/Preloader';
import { onMounted, ref, watch } from '@vue/composition-api';

export default {
  name: 'SettingsIntegrations',
  components: { Preloader, VacancyIntegrationsList },
  setup() {
    const { company } = useUser();
    const hhIntegration = useHHIntegration();
    const integrationDataLoading = ref(false);
    const integrationDataLoaded = ref(false);
    const { integrations } = useIntegrations();

    const isHHIntegration = (code) => {
      const normalizedCode = code?.toLowerCase();
      return normalizedCode === 'head_hunter' || normalizedCode === 'head_hunter.ru';
    };

    async function loadIntegrationData() {
      if (integrationDataLoaded.value) return;

      const ints = integrations.value;
      if (!ints?.length) return;

      const hasHHIntegration = ints.some((i) => isHHIntegration(i.code));

      if (hasHHIntegration && !hhIntegration.integrationData.value) {
        integrationDataLoading.value = true;
        try {
          await hhIntegration.fetchIntegrationData();
        } finally {
          integrationDataLoading.value = false;
        }
      }

      integrationDataLoaded.value = true;
    }

    onMounted(() => {
      loadIntegrationData();
    });

    watch(
      () => integrations.value?.length,
      (newLength, oldLength) => {
        if (newLength && newLength !== oldLength && !integrationDataLoaded.value) {
          loadIntegrationData();
        }
      },
      { immediate: false },
    );

    return {
      integrations,
      integrationDataLoading,
      company,
    };
  },
};
</script>

<style scoped>

</style>
